<template>
  <tooltip
    placement="top"
    :options="{ hideOnClick: true }"
    :disabled="breakpoints().sm"
  >
    <template #trigger>
      <span class="link" @click="handleUnlinkCall">
        <i class="fa-solid fa-link-slash"></i>
      </span>
    </template>
    <template #tooltip> Unlink Call </template>
  </tooltip>
</template>

<script>
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import Tooltip from "@/components/Tooltip.vue";

export default {
  components: {
    Tooltip
  },
  props: {
    link: {
      type: String,
      default: null
    },
    callId: {
      type: Number,
      default: null
    }
  },
  methods: {
    ...mapActions(["unlinkCall"]),
    handleUnlinkCall() {
      if (this.link) {
        this.unlinkCall({ link: this.link, call_id: this.callId }).then(() => {
          window.notify.success("Phone call was successfully unlinked.");
          EventBus.$emit("refresh-datatable");
          EventBus.$emit("refresh-linked-calls");
        });
      }
    }
  }
};
</script>

<style scoped>
.disabled {
  opacity: 0.6;
}
</style>
